/* src/app/dashboard/charts/opens-views/opens-views.component.css */
.canvas-container {
  justify-content: stretch;
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
}
.canvas-block {
  display: block;
  width: 100%;
}
.no-data-container {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 290px;
}
.no-data-top {
  margin-bottom: 15px;
  font-size: 1.8em;
  color: var(--primary-color);
}
/*# sourceMappingURL=opens-views.component.css.map */
